import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from './shared/theming/material/material.module';

@Component({
  selector: 'app-root',
  imports: [MaterialModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'smart-fix-admin-portal';
}
